import { rooApiUrl, workspaceName } from "../environment/Environment";
import axiosInstance from "../external-library/axios-interceptor/Interceptor";

// This should be changed to 'region'. See  #294 #295
export const REGION_PROPERTY_NAME = "adm1_en"; 

const wfsGetJson = (layerName, { propertyName } = {}) =>
  axiosInstance.get(
    `${rooApiUrl}/wfs?service=WFS&version=1.1.0&request=GetFeature&typeName=${workspaceName}:${layerName}&outputFormat=application/json` +
      (propertyName ? `&propertyName=${propertyName}` : "")
  );

export const getFeatureInfoByUrl = async (url) => {
  return await axiosInstance.get(url);
};

export const getAllFeatureOfLayerByLayerName = async (layerName) =>
  wfsGetJson(layerName);

export const getRegionsOfCountry = async (layerName, propertyName = REGION_PROPERTY_NAME) =>
  wfsGetJson(layerName, { propertyName });

export const getAllFeatureOfLayerByLayerNameAndDistrict = async (layerName,district) => {
  return await axiosInstance.get(
    `${rooApiUrl}/wfs?service=WFS&version=1.1.0&request=GetFeature&typeName=${workspaceName}:${layerName}&CQL_FILTER=district='${district}'&outputFormat=application/json`
  );
};

export const getAllDistrictByRegionName = async (layerName,regionName,filterType) => {

    regionName = regionName;

  console.log("Querying for region: " + regionName)

  return await axiosInstance.get(
    // Removed PropertyName parameter to get all properties including waste quantity data
    `${rooApiUrl}/wfs?service=WFS&version=1.1.0&request=GetFeature&typeName=${workspaceName}:${layerName}&outputFormat=application/json&cql_filter=${filterType} ILIKE '${regionName}'`
  );
};
